import React, { useEffect, useState, FC, useContext, PropsWithChildren, useRef } from 'react';
import { ThemeContext, ThemeContextType, ThemeEnum } from '../ThemeProvider';
import './Timer.css';

import ProgressBar from 'react-bootstrap/ProgressBar';

type Props = PropsWithChildren & {
    color: string,
    maxWidth: string,
    maxHeight: string,
    duration: number,
    loops: number,
    isEnabled: boolean,
    id?: string,
    max?: number,
    now: number,
}

const Timer : FC<Props>= ({color, loops, isEnabled, id, children, max, now}) => {
    const { theme } = useContext(ThemeContext) as ThemeContextType;
    const step = .5;
    return <ProgressBar style={{backgroundColor: color}} className={`timer ${theme === ThemeEnum.light ? 'bs' : ''}`} now={now} max={max}/>
}

export default Timer;